<template>
  <div class="block block-cust">
    <div class="container">
      <div class="row wrap-card">
        <div class="col-md-6 animated" v-animate="'slideInLeft'">
          <div>
            <img :src="p16" class="img-responsive" alt="" />
          </div>
          <div class="wrap-logo">
            <img :src="logo" alt="" />
          </div>
        </div>
        <div class="col-md-6 animated" v-animate="'slideInRight'">
          <div class="box-title">吉智合同</div>
          <div class="box-text">
            吉智合同系吉冉软件孵化的独立品牌产品，致力于帮助企业实现合同生命周期的极致管控、提高合同管理效率、降低风险、穿透合同业财数据。吉冉建有独立的合同产品研发，交付与运营团队，实现产品的可持续发展。
          </div>
          <hr class="hr-cust" />
          <div class="box-title">公司介绍</div>
          <div class="box-text">
            吉冉软件2014年成立，本部在南京、上海、苏州、杭州等地设有本土化交付与持续服务团队。与ULTIMUS合作成立ULTIMUS
            （VALUE-ADDED）CENTER，ULTIMUS中国增值应用研发中心。
          </div>

          <div class="btn-cust" @click="jump()">查看更多</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import p16 from "@/assets/images/home/p16.png";
import logo from "@/assets/images/logo.png";
export default {
  data() {
    return {
      p16,
      logo,
    };
  },
  methods: {
    jump() {
      this.$router.push({
        name: "about",
      });
      window.$("body,html").animate(
        {
          scrollTop: 0,
        },
        "slow"
      );
    },
  },
};
</script>

<style scoped>
.block-cust {
  background-color: #2f56ce;
}

.wrap-logo {
  text-align: center;
  margin-top: 30px;
}

.box-title {
  font-size: 32px;
  color: #fff;
  margin-bottom: 20px;
}
.box-text {
  font-size: 15px;
  color: #f3f8fe;
}
.hr-cust {
  margin: 40px 0;
}
.btn-cust {
  width: 200px;
  height: 60px;
  font-size: 20px;
  line-height: 60px;
  text-align: center;
  background-color: #fff;
  color: #2f56ce;
  cursor: pointer;
  margin-top: 40px;
}
</style>